import { DatabaseDocumentType } from './database-document-type.model';
import { DatabaseIndexNameType } from './database-index-name.model';
import { DatabaseType } from './database-type.model';
import { HttpError } from './http-error.enum';
import { LanguageType } from './language-type.enum';
import { Month } from './month.enum';

export class Constants {
  public static readonly DEBOUNCE_TIME_FOR_POST_API_WORKSHEET = 800;
  public static readonly DEFAULT_LANGUAGE_TYPE = LanguageType.English;
  public static readonly DEFAULT_DECIMALS = 2;

  // caching constants
  public static readonly CACHE_MAX_AGE = 3600000; // 1 hour
  public static readonly CACHEABLE_HTTP_METHODS = ['GET'];
  public static readonly CACHEABLE_URLS = [
    'material/types?active-only=true',
    'material/dry-range',
    'material/fertilizer?include-custom=false'
  ];

  // HTTP errors
  public static readonly HTTP_SERVICE_DOWN = 500;
  public static readonly HTTP_RESOURCE_NOT_FOUND = 404;
  public static readonly HTTP_FORBIDDEN = 403;
  public static readonly HTTP_ERRORS = [
    // {
    //   id: HttpError.HTTP_BAD_REQUEST,
    //   i18nkey: 'http.error.400'
    // },
    // {
    //   id: HttpError.HTTP_UNAUTHORIZED,
    //   i18nkey: 'http.error.401'
    // },
    {
      id: HttpError.HTTP_FORBIDDEN,
      i18nkey: 'http.error.403'
    },
    {
      id: HttpError.HTTP_REQUEST_TIMEOUT,
      i18nkey: 'http.error.408'
    },
    {
      id: HttpError.HTTP_BAD_GATEWAY,
      i18nkey: 'http.error.502'
    },
    {
      id: HttpError.HTTP_GATEWAY_TIMEOUT,
      i18nkey: 'http.error.504'
    }
  ];

  public static readonly ASSESSMENTS_URL = 'http://www.geologyontario.mndm.gov.on.ca/mndmfiles/afri/data/imaging/20000013572/';

  public static readonly PUBLICATIONS_URL = 'http://www.geologyontario.mndm.gov.on.ca/mndmaccess/mndm_dir.asp?type=pub&id=';

  // public static readonly PUBLICATIONS_URL = 'http://www.geologyontario.mndm.gov.on.ca/mndmfiles/afri/data/records/';

  public static readonly MONTHS = [
    {
      id: Month.January,
      i18nkey: 'month.1',
      shortKey: 'month.1.short',
    },
    {
      id: Month.February,
      i18nkey: 'month.2',
      shortKey: 'month.2.short',
    },
    {
      id: Month.March,
      i18nkey: 'month.3',
      shortKey: 'month.3.short',
    },
    {
      id: Month.April,
      i18nkey: 'month.4',
      shortKey: 'month.4.short',
    },
    {
      id: Month.May,
      i18nkey: 'month.5',
      shortKey: 'month.5.short',
    },
    {
      id: Month.June,
      i18nkey: 'month.6',
      shortKey: 'month.6.short',
    },
    {
      id: Month.July,
      i18nkey: 'month.7',
      shortKey: 'month.7.short',
    },
    {
      id: Month.August,
      i18nkey: 'month.8',
      shortKey: 'month.8.short',
    },
    {
      id: Month.September,
      i18nkey: 'month.9',
      shortKey: 'month.9.short',
    },
    {
      id: Month.October,
      i18nkey: 'month.10',
      shortKey: 'month.10.short',
    },
    {
      id: Month.November,
      i18nkey: 'month.11',
      shortKey: 'month.11.short',
    },
    {
      id: Month.December,
      i18nkey: 'month.12',
      shortKey: 'month.12.short',
    }

  ];

  public static readonly EMPTY_TEXT = { en: '', fr: '' };

  public static readonly RESULT_TYPE_OPTIONS = [
    {
      id: DatabaseDocumentType.recordIndex,
      name: 'Record Index',
      i18nkey: 'record.index',
      checked: true,
      displayOrder: 1
    },
    {
      id: DatabaseDocumentType.documentContents,
      name: 'Document Contents',
      i18nkey: 'document.contents',
      checked: false,
      displayOrder: 2
    }
  ];

  public static readonly DATABASE_TYPE_OPTIONS = [
    {
      id: DatabaseType.abandonedMines,
      name: 'Abandoned Mines',
      index: [DatabaseIndexNameType.abandonedMines],
      i18nkey: 'abandoned.mines',
      checked: true,
      displayOrder: 1
    },
    {
      id: DatabaseType.assessment,
      name: 'Assessment Files',
      index: [DatabaseIndexNameType.assessment, DatabaseIndexNameType.assessment_pdf],
      i18nkey: 'assessment',
      checked: true,
      displayOrder: 2
    },
    {
      id: DatabaseType.drillHoles,
      name: 'Drill Holes',
      index: [DatabaseIndexNameType.drillHoles],
      i18nkey: 'drill.hole',
      checked: true,
      displayOrder: 3
    },
    {
      id: DatabaseType.mineralInventory,
      name: 'Mineral Inventory',
      index: [DatabaseIndexNameType.mineralInventory],
      i18nkey: 'mineral.inventory',
      checked: true,
      displayOrder: 4
    },
    {
      id: DatabaseType.publications,
      name: 'Publications',
      index: [DatabaseIndexNameType.publication, DatabaseIndexNameType.publication_pdf],
      i18nkey: 'publications',
      checked: true,
      displayOrder: 5
    },
    {
      id: DatabaseType.allDatabases,
      name: 'All Databases',
      index: [],
      i18nkey: 'all.databases',
      checked: true,
      displayOrder: 6
    }
  ];

  public static readonly PUBLICATION_AUTHOR = ['publication-author'];

  public static readonly PUBLICATION_SERIES = ['publication-series'];

  public static readonly RECORDS = [DatabaseIndexNameType.assessment, DatabaseIndexNameType.drillHoles, DatabaseIndexNameType.mineralInventory, DatabaseIndexNameType.publication, DatabaseIndexNameType.abandonedMines];

  public static readonly DOCUMENTS = [DatabaseIndexNameType.assessment_pdf, DatabaseIndexNameType.publication_pdf];

}
